import type { CourseProgress } from '@/domain/model/CourseProgress';

export const FULL_PROGRESS_PERCENTAGE = 100;

const RESUME_MAX_PERCENTAGE = 98;

export const coursePercentage = (
  progressByCourseId: Record<string, CourseProgress>,
  courseId: string,
): number => progressByCourseId[courseId]?.progressPercentage ?? 0;

export const isCourseCompleted = (
  progressByCourseId: Record<string, CourseProgress>,
  courseId: string,
): boolean => progressByCourseId[courseId]?.completed ?? false;

export const resumePercentage = (progress: CourseProgress | undefined): number => {
  if (!progress || progress.completed) return 0;
  if (progress.progressPercentage <= 0) return 0;
  if (progress.progressPercentage >= RESUME_MAX_PERCENTAGE) return 0;
  return progress.progressPercentage;
};

export const overallPercentage = (
  progressByCourseId: Record<string, CourseProgress>,
  courseIds: string[],
): number => {
  if (courseIds.length === 0) return 0;
  const watched = courseIds.reduce(
    (total, courseId) => total + coursePercentage(progressByCourseId, courseId),
    0,
  );
  return watched / courseIds.length;
};
